import { render, staticRenderFns } from "./surveillancePersonInfo.vue?vue&type=template&id=34d68ec4&scoped=true"
import script from "./surveillancePersonInfo.vue?vue&type=script&lang=js"
export * from "./surveillancePersonInfo.vue?vue&type=script&lang=js"
import style0 from "./surveillancePersonInfo.vue?vue&type=style&index=0&id=34d68ec4&prod&lang=less"
import style1 from "./surveillancePersonInfo.vue?vue&type=style&index=1&id=34d68ec4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34d68ec4",
  null
  
)

export default component.exports